import React from 'react';
import { startDate, endDate } from '../config.js';
import { dateStringToFriendly } from '../utils.js';
import { t } from '../lang/trans.js';

const showRestriction = restriction => {
  // TODO: handle holidays

  const weekdaysMap = 0b0111110;
  const weekendsMap = 0b1000001;
  const dailyMap = 0b1111111;
  const daysMap = restriction.daysOfWeek & dailyMap;

  const weekdays = daysMap === weekdaysMap;
  const weekends = daysMap === weekendsMap;
  const daily = daysMap === dailyMap;

  let weeklySchedule;

  if(daily) {
    weeklySchedule = null;
  } else if(weekdays) {
    weeklySchedule = <span>{t('weekdays')}</span>;
  } else if(weekends) {
    weeklySchedule = <span>{t('weekends')}</span>;
  } else {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    weeklySchedule = <span>
      {days.filter((day, idx) => ((1 << idx) & restriction.daysOfWeek)).map(t).join(', ')}
    </span>
  }

  let yearlySchedule;
  if(restriction.from === startDate && restriction.to === endDate) {
    yearlySchedule = null;
  } else {
    yearlySchedule = <span>{t('just from')} {dateStringToFriendly(restriction.from)} {t('just to')} {dateStringToFriendly(restriction.to)}</span>;
  }

  if(!weeklySchedule && !yearlySchedule) {
    return null;
  }

  return <span>{weeklySchedule} {yearlySchedule}</span>
};

export default ({ train }) => {
  if(train.restrictions.length === 0) {
    return null;
  }

  const restrictionsDom = train.restrictions.map(showRestriction).filter(r => !!r);

  if(restrictionsDom.length === 0) {
    return null;
  }

  return <span>
    &mdash;
    {' '}{restrictionsDom.map((restrictionDom, idx, allRestrictions) =>
      <span key={idx}>
        {restrictionDom}
        {idx !== allRestrictions.length - 1 ? ' / ' : null}
      </span>
    )}
    {' '}{t('only')}
  </span>;
}



/** WEBPACK FOOTER **
 ** ./src/components/TrainRestrictions.js
 **/